// Форматтеры для админ-панели (байты, относительное время).
export function fmtBytes(n: number): string {
  if (!n || n < 1) return '0'
  const u = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ']
  let i = 0
  let v = n
  while (v >= 1024 && i < u.length - 1) { v /= 1024; i++ }
  return `${v >= 100 || i === 0 ? Math.round(v) : v.toFixed(1)} ${u[i]}`
}

// unix-секунды -> «5 мин назад». 0/пусто -> «никогда».
export function fmtAgoUnix(sec: number): string {
  if (!sec) return 'никогда'
  const d = Math.max(0, Math.floor(Date.now() / 1000 - sec))
  if (d < 60) return 'только что'
  if (d < 3600) return `${Math.floor(d / 60)} мин назад`
  if (d < 86400) return `${Math.floor(d / 3600)} ч назад`
  return `${Math.floor(d / 86400)} дн назад`
}

export function fmtDay(s: string | null): string {
  return s ? new Date(s).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '—'
}

// дней до даты (может быть отрицательным = просрочен)
export function daysLeft(s: string | null): number | null {
  if (!s) return null
  return Math.floor((new Date(s).getTime() - Date.now()) / 86400000)
}
